export function getImage(src, { baseURL } = {}) {
  return {
    url: baseURL + src,
  };
}
